import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap, throttleTime } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionCoopSendPointsResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopSendPoints = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.SendCoopPoints), throttleTime(2000), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.SendCoopPoints,
            props: {
                coopId: action.coopId,
                playerId: action.playerId,
            },
        });
    }), switchMap(function (res) {
        var rewardItem = {
            amount: res.amount,
            typeId: res.itemId,
        };
        return from([
            actionAddPelletsInScreenCenterAnimation(1, [
                {
                    amount: rewardItem.amount || 0,
                    icon: getResourceIconInfo(rewardItem).icon,
                },
            ]),
            actionInventoryInfoAddResource([rewardItem]),
            actionCoopSendPointsResponse(res),
        ]);
    }), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopSendPoints.ts
// module id = 1824
// module chunks = 3